/* @flow */
import React, {PropTypes} from 'react';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import Translate from 'react-translate-component';
import { CountryPicker, Profession, SpinnerButton, InputField, ValidationError } from 'components';
import { WorkerService, Utils } from 'frilans-finans';
import BankInfoForm from '../../settings/salary-info/bank-info-form';

export class AddNewCoworker extends React.Component {

  static propTypes = {
    setValidationErrors: PropTypes.func.isRequired,
    clearValidationErrors: PropTypes.func.isRequired,
    validationErrors: PropTypes.object,
    close: PropTypes.func.isRequired,
    bankInfo: PropTypes.object.isRequired,
    setClearingNumberSuppressError: PropTypes.func.isRequired,
    setAccountNumberSuppressError: PropTypes.func.isRequired,
    resetBankInfo: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      formData: {
        firstName: {},
        lastName: {},
        cellphone: {},
        street: {},
        city: {},
        co: {},
        zip: {},
        socialSecurityNumber: {},
        professionId: {},
        email: {},
        country: {}
      },
      showErrorWithoutBlur: false,
      posting: false,
      countryError: false,
      postError: false,
      acceptAddCoworker: false
    };

    this.saveNewCoworker = this.saveNewCoworker.bind(this);
    this.inputFieldChange = this.inputFieldChange.bind(this);
    this.setCountry = this.setCountry.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handlePostError = this.handlePostError.bind(this);
    this.handleAcceptAddCoworkerClick = this.handleAcceptAddCoworkerClick.bind(this);
  }

  componentWillMount () {
    this.props.resetBankInfo();
  }

  getBankInfoFields () {
    if (this.props.bankInfo.selectedBank === 'IBAN') {
      return {
        internationalAccount: 'on',
        bic: this.props.bankInfo.clearingNumber.value,
        iban: this.props.bankInfo.accountNumber.value
      };
    }

    return {
      internationalAccount: 'off',
      accountClearingNumber: this.props.bankInfo.clearingNumber.value,
      accountNumber: this.props.bankInfo.accountNumber.value
    };
  }

  saveNewCoworker () {
    let params = Utils.getPostParams(this.state.formData);
    params = Object.assign(params, this.getBankInfoFields());
    params.professionId = this.state.formData.professionId.id;
    this.setState({
      posting: true
    }, () => {
      WorkerService.post(params)
        .then(() => {
          this.props.clearValidationErrors();
          this.props.resetBankInfo();
          this.props.close();
        })
        .catch(this.handlePostError);
    });
  }

  handlePostError (error) {
    let errors = WorkerService.getError(error);

    if (error.response.status === 422) {
      this.props.setValidationErrors(error.response.data);
    };

    this.setState({
      postError: true,
      posting: false,
      errorMessage: errors
    });
  }

  setCountry (countryId) {
    this.inputFieldChange('country', {value: countryId, valid: true});
  }

  validateCountry () {
    let countryInvalid = !this.state.formData.country.value;

    this.setState({
      countryError: countryInvalid
    });

    return !countryInvalid;
  }

  inputFieldChange (name, values) {
    var tempFormValues = this.state.formData;
    name = name.replace('add-worker-', '');

    Object.assign(tempFormValues[name], values);
    this.setState({formData: tempFormValues});
  }

  onSubmit (e) {
    e.preventDefault();

    this.props.setClearingNumberSuppressError(false);
    this.props.setAccountNumberSuppressError(false);

    this.setState({
      showErrorWithoutBlur: true
    }, () => {
      if (this.validateCountry() &&
        Utils.validateInputValues(this.state.formData) &&
        this.props.bankInfo.clearingNumber.isValid &&
        this.props.bankInfo.accountNumber.isValid &&
        this.state.formData.professionId.id) {
        this.saveNewCoworker();
      }
    });
  }

  handleAcceptAddCoworkerClick (e) {
    this.setState({
      acceptAddCoworker: e.target.checked
    });
  }

  renderCountryError () {
    if (this.state.countryError) {
      return (<p className="error"><Translate content='COUNTRY_ERROR' /></p>);
    }
  }

  renderPostError () {
    if (this.state.postError) {
      if (!this.state.errorMessage) {
        return (<ValidationError errors={this.props.validationErrors} />);
      } else {
        return (
          <div>
            {this.state.errorMessage.map((error, i) => {
              return (
                <p className="error" key={i}>{error}</p>
              );
            })}
          </div>
        );
      }
    }
  }

  render () {
    return (
      <div className='addNewCoworker'>
        <form noValidate onSubmit={this.onSubmit}>
          <h2><Translate content='ADD_COWORKER'/></h2>
          <div className='addNewCoworkerFields'>
            <InputField type='text' name='add-worker-firstName'
              placeholder={proxyCounterpart('FIRST_NAME')}
              required='true' minLength='2'
              validationType='text'
              callback={this.inputFieldChange}
              errorMessage={proxyCounterpart('FIRST_NAME_ERROR')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />

            <InputField type='text' name='add-worker-lastName'
              placeholder={proxyCounterpart('LAST_NAME')}
              required='true' minLength='2'
              validationType='text'
              callback={this.inputFieldChange}
              errorMessage={proxyCounterpart('LAST_NAME_ERROR')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />

            <InputField type='text' name='add-worker-cellphone'
              placeholder={proxyCounterpart('MOBILE_PHONE')}
              required='true' minLength='0'
              validationType='tel'
              callback={this.inputFieldChange}
              errorMessage={proxyCounterpart('"VALIDATION_CELLPHONE_PHONENUMBER"')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />

            <InputField type='text' name='add-worker-socialSecurityNumber'
              placeholder={
                proxyCounterpart('PERSONAL_NUMBER') +
                '(' + proxyCounterpart('PERSONAL_NUMBER_FORMAT') + ')'
              }
              required='true' minLength='3'
              validationType='personalNumber'
              callback={this.inputFieldChange}
              errorMessage={proxyCounterpart('PERSONAL_NUMBER_ERROR')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />

            <InputField type='text' name='add-worker-email'
              placeholder={proxyCounterpart('EMAIL')}
              required='false'
              validationType='email'
              errorMessage={proxyCounterpart('EMAIL_INVALID_ERROR')}
              callback={this.inputFieldChange}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />

            <Profession value='' name='add-worker-professionId'
              showErrorWithoutBlur={this.state.showErrorWithoutBlur} callback={this.inputFieldChange} />
          </div>

          <hr/>

          <div className='addNewCoworkerFields'>
            <InputField type='text' name='add-worker-street'
              placeholder={proxyCounterpart('STREET_ADDRESS')}
              required='true' minLength='3'
              validationType='text'
              errorMessage={proxyCounterpart('ADDRESS_ERROR')}
              callback={this.inputFieldChange}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />

            <InputField type='text' name='add-worker-co'
              placeholder={proxyCounterpart('CO')}
              required='true' minLength='0'
              validationType='text'
              callback={this.inputFieldChange}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />

            <div className='input-wrapper'>
              <InputField type='text' name='add-worker-zip'
                placeholder={proxyCounterpart('POSTAL_CODE_ABBR')}
                required='true' minLength='3'
                errorMessage={proxyCounterpart('POSTAL_CODE_ERROR')}
                validationType='text'
                callback={this.inputFieldChange}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur}
              />

              <InputField type='text' name='add-worker-city'
                placeholder={proxyCounterpart('CITY')}
                required='true' minLength='3'
                validationType='text'
                errorMessage={proxyCounterpart('CITY_ERROR')}
                callback={this.inputFieldChange}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur}
              />
            </div>

            <div className='input-wrapper add-new-coworker-country'>
              <CountryPicker
                defaultValue='SWEDEN'
                showErrorWithoutBlur={this.state.showErrorWithoutBlur}
                setCountry={this.setCountry} />
            </div>
          </div>

          <hr/>

          <BankInfoForm />

          {this.renderCountryError()}
          {this.renderPostError()}
          <div className='checkbox-holder'>
            <input
              id='agree-add-coworker'
              type='checkbox'
              name='agree-add-coworker'
              value={this.state.acceptAddCoworker}
              onClick={this.handleAcceptAddCoworkerClick} />
            <label htmlFor='agree-add-coworker'>
              <span></span>
              {proxyCounterpart('ACCEPT_NEW_COWORKER')}
            </label>
          </div>
          <div className='button-holder'>
            <a className='btn outlined blue' onClick={this.props.close}><span><Translate content='CLOSE'/></span></a>
            <SpinnerButton text={proxyCounterpart('ADD')}
              loading={this.state.posting} disabled={!this.state.acceptAddCoworker} classes='btn'/>
          </div>

        </form>

      </div>
    );
  }
}

export default AddNewCoworker;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/add-new-coworker.js
 **/